import { useEffect } from 'react';
import { usePrevious } from 'react-use';

import { useSelectedSuggestionEvidenceContext } from '@/modules/aiSuggestions/context/SelectedSuggestionEvidence.context';

/**
 * When transitioning from a non-DP section into a DP section, clear any tab
 * override left over from a magnifying-glass click. The documents viewer
 * forces the diagram tab on entry; without this reset, a stale 'document'
 * override would prevent later DP magnifying-glass clicks from re-triggering
 * the override (the value wouldn't change), leaving the user stuck on the
 * diagram instead of switching to the document.
 */
export function useResetEvidenceOnDPEntry(isDPSection: boolean) {
  const { setDocumentPanelProps } = useSelectedSuggestionEvidenceContext();
  const prevIsDPSection = usePrevious(isDPSection);

  useEffect(() => {
    if (prevIsDPSection === false && isDPSection) {
      setDocumentPanelProps((prev) => ({
        ...prev,
        activeDocumentViewerTab: undefined,
        annotations: undefined,
        activeAnnotationIndex: undefined,
        searchQuery: '',
        searchLoading: false,
      }));
    }
  }, [isDPSection, prevIsDPSection, setDocumentPanelProps]);
}
